import React, { useRef, useState } from 'react'
import logo from "../../assets/boxxdocks-logo-grey.svg"
import { useSearchParams, useParams } from 'react-router-dom'
import camera from "../../assets/camera-icon.svg"
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { useAddServiceManagementMutation } from "../../redux/ServiceApi";
import { toast } from "react-toastify";
import Loader from "../../assets/loader.gif"
import imageCompression from "browser-image-compression";

import { setStateRefresh } from "../../redux/globalSlice";

const AddPhoto = () => {
    const [addServiceManagement] = useAddServiceManagementMutation();
    const dispatch = useDispatch();
    const stateRefresh = useSelector((state) => state.global.stateRefresh);
    const [imageFile, setImageFile] = useState(null);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const customerNumber = searchParams.get("customerNumber");
    const region = searchParams.get("region");
    const { id } = useParams();
    const comment = localStorage.getItem("serviceComment") || "";
    const fileInputRef = useRef(null);
    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (file) {
            try {
                const options = {
                    maxSizeMB: 1,
                    maxWidthOrHeight: 1024,
                    useWebWorker: true,
                };
                const compressedBlob = await imageCompression(file, options);

                // Convert Blob to File with a proper name
                const compressedFile = new File(
                    [compressedBlob],
                    file.name, // or `${Date.now()}-${file.name}` to avoid collisions
                    { type: compressedBlob.type }
                );

                setImageFile(compressedFile);
                setError("");
            } catch (error) {
                console.error("Compression error:", error);
                setError("Image compression failed");
            }
        }

    };
    const openFilePicker = () => {
        fileInputRef.current.click();
    };
    const submitHandler = () => {
        if (!imageFile) {
            setError("Please attach an image before continuing.");
            return;
        }
        let serviceReportingType = localStorage.getItem("serviceReportingType");
        let serviceFirstName = localStorage.getItem("serviceFirstName");
        let serviceLastName = localStorage.getItem("serviceLastName");
        let serviceEmail = localStorage.getItem("serviceEmail");
        let anonymous = localStorage.getItem("serviceAnonymous");
        let comment = localStorage.getItem("serviceComment");
        const formData = new FormData();
        formData.append("customerNumber", customerNumber);
        formData.append("addressId", id);
        formData.append("reportingType", serviceReportingType || false);
        formData.append("firstName", serviceFirstName || "");
        formData.append("lastName", serviceLastName || "");
        formData.append("email", serviceEmail || "");
        formData.append("anonymous", anonymous || "");
        formData.append("comment", comment || "");
        formData.append("region", region || "");
        formData.append("image", imageFile);
        setLoading(true);
        addServiceManagement(formData)
            .unwrap()
            .then((res) => {
                if (res?.statusCode === 200) {
                    localStorage.setItem("getServicePage", "Confirmation");
                    dispatch(setStateRefresh(!stateRefresh));
                    setLoading(false);
                    localStorage.removeItem("serviceReportingType");
                    localStorage.removeItem("serviceFirstName");
                    localStorage.removeItem("serviceLastName");
                    localStorage.removeItem("serviceEmail");
                    localStorage.removeItem("serviceAnonymous");
                    localStorage.removeItem("serviceComment");
                    setImageFile(null);
                }
            })
            .catch((err) => {
                setLoading(false);
                toast.error(err?.data?.message);

            });


    };
    const handleSkip = () => {

        let serviceReportingType = localStorage.getItem("serviceReportingType");
        let serviceFirstName = localStorage.getItem("serviceFirstName");
        let serviceLastName = localStorage.getItem("serviceLastName");
        let serviceEmail = localStorage.getItem("serviceEmail");
        let anonymous = localStorage.getItem("serviceAnonymous");
        let comment = localStorage.getItem("serviceComment");
        const formData = new FormData();
        formData.append("customerNumber", customerNumber);
        formData.append("addressId", id);
        formData.append("reportingType", serviceReportingType || false);
        formData.append("firstName", serviceFirstName || "");
        formData.append("lastName", serviceLastName || "");
        formData.append("email", serviceEmail || "");
        formData.append("anonymous", anonymous || "");
        formData.append("comment", comment || "");
        formData.append("region", region || "");
        formData.append("image", imageFile || "");
        setLoading(true);
        addServiceManagement(formData)
            .unwrap()
            .then((res) => {
                if (res?.statusCode === 200) {
                    localStorage.setItem("getServicePage", "Confirmation");
                    dispatch(setStateRefresh(!stateRefresh));
                    localStorage.removeItem("serviceReportingType");
                    localStorage.removeItem("serviceFirstName");
                    localStorage.removeItem("serviceLastName");
                    localStorage.removeItem("serviceEmail");
                    localStorage.removeItem("serviceAnonymous");
                    localStorage.removeItem("serviceComment");
                    setImageFile(null);
                    setLoading(false);
                }
            })
            .catch((err) => {
                setLoading(false);
                toast.error(err?.data?.message);
            });

    };
    const clearImage = () => {
        setImageFile(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = null; // Reset the file input value
        }
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12">
                    <div className="main-content">
                        <div className="logo mx-auto">
                            <img src={logo} className="img-fluid mx-auto" alt="logo" />
                        </div>
                        <p className="mb-0 heading">Would you like to add a Photo?</p>

                        <div className="row">
                            <div className="col-md-12">
                                <div className="code-box">
                                    <div className="logo ggg text-center">
                                        {!imageFile && (
                                            <div>
                                                {/* Triggered via camera image */}
                                                <img
                                                    src={camera}
                                                    className="img-fluid"
                                                    alt="camera"
                                                    onClick={openFilePicker}
                                                    style={{ cursor: "pointer", width: "80px" }}
                                                />
                                            </div>
                                        )}

                                        {/* Hidden file input, reused for both buttons */}
                                        <input
                                            type="file"
                                            accept="image/*"
                                            capture="environment"
                                            onChange={handleFileChange}
                                            style={{ display: "none" }}
                                            ref={fileInputRef}
                                        />
                                        {loading && <img src={Loader} alt="loader" className="loader" />}
                                        {!loading && imageFile && (
                                            <div className="position-relative d-inline-block new-width-set">
                                                <img
                                                    src={URL.createObjectURL(imageFile)}
                                                    className="img-fluid uploaded-image"
                                                    alt="preview"
                                                    
                                                />
                                                <span
                                                    className="cross position-absolute"
                                                    onClick={clearImage}
                                                    style={{ cursor: "pointer", color: "white", fontSize: "15px" }}
                                                >
                                                    <FontAwesomeIcon icon={faXmark} />
                                                </span>
                                            </div>
                                        )}


                                        {error && <p style={{ color: "red" }}>{error}</p>}
                                    </div>
                                </div>

                                <div className="button-box mt-3">
                                    <div className="position-absolute">
                                        <button
                                            type="button"
                                            className={`btn-skip-s me-4 ${!comment ? "disabled" : ""}`}
                                            disabled={!comment}
                                            onClick={handleSkip}
                                        >
                                            Skip
                                        </button>


                                        {/* Attach Image button triggers same file input */}
                                        {!imageFile && (
                                            <button
                                                type="button"
                                                className="btn-continue-s"
                                                onClick={openFilePicker}
                                            >
                                                Attach Image
                                            </button>
                                        )}

                                        {/* Save shown only when image is selected */}
                                        {imageFile && (
                                            <button
                                                type="button"
                                                className="btn-continue-s"
                                                onClick={submitHandler}
                                            >
                                                Save
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddPhoto